import React from "react";

const CardBox = ({ list }) => {
  return (
    <div className="grid sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
      {list?.map((box) => (
        <div
          key={box.id}
          style={{
            border: box?.border ? "2px solid red" : "",
          }}
          className={`${box.color} rounded-2xl p-4 flex flex-col items-center text-white shadow-lg cursor-pointer`}
          onClick={box?.onClick}
        >
          <div className="w-12 h-12 flex items-center justify-center rounded-full">
            {box?.img && (
              <img src={box?.img} alt={box.title} className="w-auto h-8" />
            )}
            {box?.icon && box?.icon}
          </div>
          <h2 className="font-semibold text-lg">{box.title}</h2>
          <p className="text-sm mt-1 opacity-90 text-center">
            {box.description}
          </p>
        </div>
      ))}
    </div>
  );
};

export default React.memo(CardBox);
